import { createReducer, on } from '@ngrx/store';
import { GetFormularioResponsesSuccess, GetFormulariosAsignadosSuccess, GetFormulariosSuccess } from '../actions/formularios.actions';

export interface IFormulariosState {
  formularios: any[];
  formulariosAsignados: any[];
  formularioResponses: any[];
}

export const initialFormulariosState: IFormulariosState = {
  formularios: [],
  formulariosAsignados: [],
  formularioResponses: []
};

export const formulariosReducers = createReducer(
    initialFormulariosState,
  on(GetFormulariosSuccess, (state, { formularios }) => {
    return {
        ...state,
        formularios
    };
  }),
  on(GetFormulariosAsignadosSuccess, (state, { formulariosAsignados }) => {
    return {
        ...state,
        formulariosAsignados
    };
  }),
  on(GetFormularioResponsesSuccess, (state, { formularioResponses }) => {
    return {
        ...state,
        formularioResponses
    };
  })
);
